import { useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import moment from "moment";
import DeviceApi from "../../../../api/DeviceApi";
import DeviceMetricApi from "../../../../api/DeviceMetricApi";
import EventManager from "./common/event-manager/EventManager";
import DeviceRssi from "../../../../components/ui-components/rssi/DeviceRssi";
import Navigator from "../overview/component/navigator/Navigator";
import { DeviceName, ElectricWheelConciseDetailsWrapper, ElectricWheelDetailsConciseInnerWrapper, ElectricWheelDiagram, LeftColumnMetrics, MetricsGroup, MetricsGroupContent, MetricsGroupHeader, DetailsBigScreenContent, RightColumnMetrics, ScreenTitleBar, StatusBar, BottomBar, BottomItem, BottomItemName, BottomItemValue, DeviceStatus } from "./ElectricWheelConciseDetails.styled";
import DeviceMetricsGuage from "./component/device-metrics-guage/DeviceMetricsGuage";
import DeviceMetrics from "./component/device-metrics/DeviceMetrics";
import { DeviceStatus as DeviceOnlineStatus } from "../../../../components/ui-components/device-status/DeviceStatus";

interface ElectricWheelConciseDetailsProps {

}


let ElectricWheelConciseDetails: React.FC<ElectricWheelConciseDetailsProps> = (props) => {
    // params
    let {deviceId} = useParams();

    // api
    let deviceApi = new DeviceApi();
    let deviceMetricApi = new DeviceMetricApi();

    // state
    let [deviceView, setDeviceView] = useState<any>(null);
    let [deviceTemplateConfiguration, setDeviceTemplateConfiguration] = useState(null);
    let [sensorError, setSensorError] = useState(false);

    
    // reference
    let eventManagerRef = useRef(new EventManager());

    // functions
    let fetchDeviceView = async () => {
        let deviceView = (await deviceApi.getDeviceViewByDeviceId(deviceId)).data.data;
        let deviceConfiguration = JSON.parse(deviceView.deviceTemplate.configuration);
        setDeviceView(deviceView);
        setDeviceTemplateConfiguration(deviceConfiguration);
    };

    let fetchLatestDeviceMetrics = async () => {
        if (deviceId == null) {
            return;
        }
        let latestDeviceMetricsSeriesList = (await deviceMetricApi.getRealtimeDeviceMetricsSeries(deviceId, true)).data.data;
        eventManagerRef.current.notifyRealtimeDeviceMetricsSeriesUpdated(latestDeviceMetricsSeriesList);

        let sensorError = false;
        for (let latestDeviceMetricsSeries of latestDeviceMetricsSeriesList) {
            let property = latestDeviceMetricsSeries.property;
            let metrics = latestDeviceMetricsSeries.metrics;
            let latestMetric = metrics[metrics.length - 1];
            if (property.min && Number(latestMetric.value) < Number(property.min)) {
                sensorError = true;
            } else if (property.max && Number(latestMetric.value) > Number(property.max)) {
                sensorError = true;
            }
        }
        setSensorError(sensorError);
    };

    // effects
    useEffect(() => {
        fetchDeviceView();
        let refreshTask = window.setInterval(fetchLatestDeviceMetrics, 5 * 1000);
        return ()=> window.clearInterval(refreshTask);
    }, [deviceId]);

    // render
    return <ElectricWheelConciseDetailsWrapper>
        { deviceView && <ElectricWheelDetailsConciseInnerWrapper>
            <ScreenTitleBar>
                <Navigator selected="DEVICE_DETAILS" />
            </ScreenTitleBar>

            <StatusBar>
                <DeviceName>{deviceView.device.name}</DeviceName>
                <DeviceStatus style={{backgroundColor: sensorError ? 'rgba(255, 0, 0, 0.5)' : 'rgba(28, 178, 115, 0.5)'}}>{sensorError ? '故障' : '正常'}</DeviceStatus>
            </StatusBar>

            <DetailsBigScreenContent>
                <LeftColumnMetrics>
                    <MetricsGroup>
                        <MetricsGroupHeader style={{color: '#b7d14b'}}>驻车压力</MetricsGroupHeader>
                        <MetricsGroupContent>
                            <DeviceMetricsGuage eventManager={eventManagerRef.current} property={deviceTemplateConfiguration.properties.find(property=> property.key == 'park_pressure')} />
                        </MetricsGroupContent>
                    </MetricsGroup>

                    <MetricsGroup>
                        <MetricsGroupHeader style={{color: '#fc656c'}}>驻车压力（趋势）</MetricsGroupHeader>
                        <MetricsGroupContent>
                            <DeviceMetrics eventManager={eventManagerRef.current} property={deviceTemplateConfiguration.properties.find(property=> property.key == 'park_pressure')} />
                        </MetricsGroupContent>
                    </MetricsGroup>
                </LeftColumnMetrics>

                <ElectricWheelDiagram src="/static/images/big-screen/electric-wheel-concise/electric-wheel-diagram.png" />

                <RightColumnMetrics>
                    <MetricsGroup>
                        <MetricsGroupHeader style={{color: '#b7d14b'}}>驻车温度</MetricsGroupHeader>
                        <MetricsGroupContent>
                            <DeviceMetricsGuage eventManager={eventManagerRef.current} property={deviceTemplateConfiguration.properties.find(property=> property.key == 'park_temperature')} />
                        </MetricsGroupContent>
                    </MetricsGroup>

                    <MetricsGroup>
                        <MetricsGroupHeader style={{color: '#fc656c'}}>驻车温度（趋势）</MetricsGroupHeader>
                        <MetricsGroupContent>
                            <DeviceMetrics eventManager={eventManagerRef.current} property={deviceTemplateConfiguration.properties.find(property=> property.key == 'park_temperature')} />
                        </MetricsGroupContent>
                    </MetricsGroup>
                </RightColumnMetrics>
            </DetailsBigScreenContent>

            <BottomBar>
                <BottomItem>
                    <BottomItemName>设备状态：</BottomItemName>
                    <BottomItemValue><DeviceOnlineStatus status={deviceView.device.status} /></BottomItemValue>
                </BottomItem>

                <BottomItem>
                    <BottomItemName>信号强度：</BottomItemName>
                    <BottomItemValue><DeviceRssi deviceRssi={deviceView.node.rssi}/></BottomItemValue>
                </BottomItem>

                <BottomItem>
                    <BottomItemName>最后在线时间：</BottomItemName>
                    <BottomItemValue>{moment(Number(deviceView.device.lastSeenTime)).format("YYYY-MM-DD HH:mm:ss")}</BottomItemValue>
                </BottomItem>
            </BottomBar>
        </ElectricWheelDetailsConciseInnerWrapper> }
    </ElectricWheelConciseDetailsWrapper>
};

export default ElectricWheelConciseDetails;
